import { Center } from "@chakra-ui/react"

export const EmptyBox = () => {
    return(
        <Center fontSize='22px' fontWeight='lg'>No Data Found</Center>
    )
}